import React, { useContext, useEffect, useRef, useState } from "react";
import { Junction, JunctionEdge } from "./queries/types";
import { GetJunctionNode, GetJunctionNodeForMultiple } from "./queries/queries";
import { useLazyQuery } from "@apollo/client";
import { AppContext } from "../../../../../../context/context";
import { EMPTY_STRING } from "../../../../../../utils/constants";
import { Button } from "../../../../../../stories/Button/Button";
import { useReactToPrint } from "react-to-print";
import TransformImage from "../../../../../../images/transForm.png";
import TransformLogo from "../../../../../../images/TransformLogo.svg";
import EduateLogo from "../../../../../../images/EduateLogo.svg";
import ArcadisLogo from "../../../../../../images/Arcadis_Logo.png";
interface Props {
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
  selectedJunctions: number[];
}

export interface nodeVar {
  ids: number[];
  token?: string;
}

const PrintJunctionDetails = ({ setModalFlag, selectedJunctions }: Props) => {
  const contentRef = useRef<HTMLDivElement>(null);

  const [GetJunctionByNode, { data }] = useLazyQuery<
    { nodes: Junction[] },
    nodeVar
  >(GetJunctionNodeForMultiple);
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (selectedJunctions) {
          GetJunctionByNode({
            variables: {
              ids: [...selectedJunctions]
            }
          });
        }
      } catch (err) {
        console.error((err as Error).message);
      }
    };
    fetchData();
  }, [GetJunctionByNode, selectedJunctions]);
  const reactToPrintFn = useReactToPrint({ contentRef });

  return (
    <>
      <div className="print-junction">
        <style type="text/css" media="print" scoped>
          {`
      @page {
     height: 4in;
    width: 6in;
    margin: 0;
  }
  body {
    margin: 0;
  }
  .print-junction__data{
   height: 4in;
    width: 6in;
    margin:0
  }
.print-junction__block{
height:100%;
margin:0
}
  `}
        </style>
        <div className="print-junction__data" ref={contentRef}>
          {data
            ? data.nodes.map((res: Junction) => {
                return (
                  <div className="print-junction__block">
                    <div className="print-junction__block--data">
                      <div className="print-junction__block--flex">
                        <div className="print-junction__block--transform">
                          <img src={TransformImage} alt="" />
                        </div>
                        <div className="print-junction__block--title">
                          <b>{res.customer.name}</b>
                          <span>Asset Management System</span>
                        </div>
                      </div>
                      <div className="print-junction__block--label">
                        <b>Junction Code : </b>
                        <img src={TransformLogo} alt="" />
                        <b>{res.code}</b>
                      </div>
                      <div className="print-junction__block--junction">
                     <div>
                     <b>Junction Name:</b>
                        <span className="print-junction__block--junction--name">
                          {res.name}
                        </span>
                      </div>
                        <div className="print-junction__block--junction--helpdesk">
                          <b>HELPDESK </b>
                          <span>080 2294 2926</span>
                        </div>
                      </div>
                      <div className="print-junction__block--powered-by">
                        <b>Powered by</b>
                        <div>
                          <img src={EduateLogo} alt="" />
                          {" "} My-Eduate
                        </div>

                        <div>
                          <img src={ArcadisLogo} alt="" /> ARCADIS
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            : null}
        </div>
      </div>

      <Button mode="print" onClick={reactToPrintFn} />

      <Button
        mode="cancel"
        onClick={() => {
          setModalFlag(false);
        }}
      />
    </>
  );
};

export default PrintJunctionDetails;
